import { candidateModelModule } from '../../models/candidate';
import { assessmentInvitationModelModule } from '../../models/assessment-invitation';
import { appConfig } from '../../constants/app-config';
import { assessmentModelModule } from '../../models/assessment';
import { assessmentResultModelModule } from '../../models/assessment-result';
import { challengeModelModule } from '../../models/challenge';
import { teamCandidateModelModule } from '../../models/team-candidate';
import { productTypeServiceModule } from '../product-type-service/product-type-service';
import { modelHelperModule } from '../../models/model-helper';

export const invitationsServiceModule = angular
  .module('Q.services.invitations-service', [
    candidateModelModule,
    assessmentModelModule,
    assessmentResultModelModule,
    assessmentInvitationModelModule,
    challengeModelModule,
    teamCandidateModelModule,
    productTypeServiceModule,
    modelHelperModule,
  ])

  .factory(
    'invitationsService',
    function (
      $http,
      Candidate,
      Challenge,
      Assessment,
      AssessmentResult,
      AssessmentInvitation,
      TeamCandidate,
      accountService,
      $q,
      PT,
      ModelHelper,
    ) {
      const baseRoute = `${appConfig.apiRoot}assessment_invitations`;
      const authRoute = `${appConfig.apiRoot}assessment_result_auths`;

      const arRecapState = {
        invited: 'has already been Invited',
        started: 'has already been Invited and has Started',
        submitted: 'has already Submitted',
        submitting: 'has already Submitted',
      };

      const injectAuth = (auth) => {
        if (auth) {
          if (auth.assessment) {
            auth.assessment = Assessment.inject(
              ModelHelper.deserialize(Assessment, auth.assessment),
            );
          }
          if (auth.assessmentResult) {
            auth.assessmentResult = AssessmentResult.inject(
              ModelHelper.deserialize(AssessmentResult, auth.assessmentResult),
            );
          }
          if (auth.challenges) {
            auth.challenges = auth.challenges.map((challenge) =>
              Challenge.inject(ModelHelper.deserialize(Challenge, challenge)),
            );
          }
          if (auth.invitation) {
            auth.invitation = AssessmentInvitation.inject(
              ModelHelper.deserialize(AssessmentInvitation, auth.invitation),
            );
          }
          if (auth.candidate) {
            auth.candidate = Candidate.inject(
              ModelHelper.deserializeWithUiPrefs(Candidate, auth.candidate),
            );
            accountService.setLoginAccount(auth.candidate, {
              showLoadingPanel: false,
            });
          }
        }
        return auth;
      };

      const AUTH_INCLUDES = [
        'challenges.digest',
        'assessment.team',
        'assessment.team.customer',
        'assessment_result.team_candidate',
        'assessment_result.solutions',
        'team_ids',
      ];

      let svc = {
        existingInviteData(tc, assessmentId) {
          let arRecap =
            (tc.assessmentResults || []).find(
              (ar) => ar.assessmentId === assessmentId,
            ) || {};
          let stateLabel = '';
          if (tc.isArchived() || tc.isDecided()) {
            stateLabel = `${PT.Participant} has already been ${tc.stateName()}`;
          } else if (arRecap.state) {
            stateLabel = `${PT.Participant} ${arRecapState[arRecap.state]}`;
          }
          return {
            id: tc.id,
            teamCandidate: tc,
            email: tc.email,
            name: tc.name,
            state: arRecap.state || 'none',
            stateLabel,
            submitted:
              arRecap.state === 'submitted' || arRecap.state === 'submitting',
            decided: tc.isDecided(),
            archived: tc.isArchived(),
            assessmentResultId: arRecap.id,
          };
        },

        /**
         * Checks to see if any of the candidate emails listed have already been invited to the given assessment
         * @param candidateEmails {Array} emails to check
         * @param assessmentId {String} ID of assessment
         * @returns {Promise<Array<{name, state, assessmentResultId}>>} Promise that resolves to an array of already invited summary data
         */
        findAlreadyInvited(candidateEmails, assessmentId) {
          if (candidateEmails.length) {
            return TeamCandidate.findAll({
              where: {
                assessmentIds: assessmentId,
                email: { in: candidateEmails },
              },
            }).then((tcs) =>
              tcs.map((tc) => svc.existingInviteData(tc, assessmentId)),
            );
          } else {
            return $q.resolve([]);
          }
        },

        /**
         * Invites candidates
         * @param data
         */
        inviteCandidates(data) {
          return $http
            .post(`${baseRoute}/invite_candidates`, { data })
            .then((response) => response.data && response.data.data);
        },

        authorize(accessToken, assessmentId) {
          return $http
            .post(
              `${authRoute}/authorize`,
              {
                data: {
                  assessmentId,
                  accessToken,
                },
              },
              { params: { includes: AUTH_INCLUDES } },
            )
            .then((response) =>
              injectAuth(response.data && response.data.data),
            );
        },
        register(data) {
          return $http
            .post(
              `${authRoute}/register`,
              { data },
              { params: { includes: AUTH_INCLUDES } },
            )
            .then((response) =>
              injectAuth(response.data && response.data.data),
            );
        },

        findAll(params) {
          return AssessmentInvitation.findAll(params, { useFilter: true });
        },

        cancel(invitation) {
          return AssessmentInvitation.destroy(invitation);
        },

        resend(invitation) {
          return AssessmentInvitation.resend(invitation);
        },
      };

      return svc;
    },
  );
